import Table from 'components/common/Table/Table';
import * as K from 'common/constants';

/**
 * Examples of Scalyr's table component
 */

function TableExamplePage(): JSX.Element {
  const headers = [
    { content: 'Year', field: 'year', width: 100 },
    { content: 'Make', field: 'make' },
    { content: 'Model', field: 'model' },
    { content: 'Color', field: 'color' },
  ];

  const data = [
    {
      year: '2006',
      make: 'Toyota',
      model: 'Sienna CE',
      color: 'Red',
    },
    {
      year: '2009',
      make: 'Subaru',
      model: 'Legacy',
      color: 'Gray',
    },
    {
      year: '2011',
      make: 'Audi',
      model: 'Q5',
      color: 'Black',
    },
    {
      year: '2020',
      make: 'Jeep',
      model: 'Grand Cherokee',
      color: 'White',
    },
    {
      year: '1979',
      make: 'Volkswagen',
      model: 'Westfalia Bus',
      color: 'Green',
    },
  ];

  const defaultOptions = {
    isStriped: false,
    isSortable: true,
    hoverRow: true,
  };

  const stripedOptions = {
    isStriped: true,
    isSortable: true,
    hoverRow: false,
  };

  const smallOptions = {
    isStriped: true,
    isSortable: true,
    hoverRow: false,
    size: K.SIZE.SMALL,
  };

  return (
    <section id="table" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Table</h1>

      <div className="ExamplesPage__Subhead mb-4">Default Style</div>
      <Table headers={headers} data={data} options={defaultOptions} />

      <div className="ExamplesPage__Subhead mb-4 mt-5">Striped Rows</div>
      <Table headers={headers} data={data} options={stripedOptions} />

      <div className="ExamplesPage__Subhead mb-4 mt-5">Small Table</div>
      <Table headers={headers} data={data} options={smallOptions} />
    </section>
  );
}
export default TableExamplePage;
